export function classNameBlocking(value) {
    switch (value) {
        case "Blocage client":
            return "block-client"

        case "MYPacome":
            return "block-pm"

        case "Airbnb":
            return "block-airbnb"

        case "HomeAway":
            return "block-ha"

        case "Booking":
            return "block-booking"

        case "Blocage propriétaire":
            return "block-back"

        case "unavailable":
            return "block-unavailable"
        case "Rent-Client":
            return "block-client"

        default:
            return ""
    }
}

export function titleName(value) {
    if (value == null || typeof value !== 'string') {
        return value || '';
    }
    const trimmed = value.trim();
    const lower = trimmed.toLowerCase();
    if (lower === 'rent-client') {
        return 'Blocage client';
    }
    if (lower === 'unavailable' || lower === 'block-unavailable') {
        return "Indisponibilité"
    }
    if (trimmed.startsWith("-//Airbnb Inc")) {
        return "Airbnb"
    } else if (trimmed.startsWith("-//HomeAway.com")) {
        return "HomeAway"
    } else if (trimmed.startsWith("-//admin.booking.com")) {
        return "Booking"
    } else if (trimmed.startsWith("Planning Manager")) {
        return "MYPacome"
    } else if (trimmed.startsWith("ical-gites")) {
        return "Gites de France"
    } else if (trimmed === "back") {
        return "Blocage propriétaire"
    } else if (lower === 'airbnb') {
        return "Airbnb"
    } else if (lower === 'booking') {
        return "Booking"
    } else if (lower === 'homeaway') {
        return "HomeAway"
    } else {
        return value
    }
}